import { createAsyncThunk } from '@reduxjs/toolkit';
import { actionTypes } from './constants';
import {
  getOrganizationApi,
  integrationDisconnectApi,
  saveNewIntegrationApi,
} from 'src/redesign/pages/IntegrationsPage/store/api';

export const saveNewIntegration = createAsyncThunk(
  actionTypes.SAVE_NEW_INTEGRATION,
  async (data: { integrationType: string; apiKey: string }) => {
    return await saveNewIntegrationApi(data);
  },
);

export const integrationDisconnect = createAsyncThunk(
  actionTypes.INTEGRATIONS_DISCONNECT,
  async ({ userId, value }: { userId: string; value: unknown }, { getState }) =>
    await integrationDisconnectApi(getState(), { [userId]: value }),
);

export const getOrganizations = createAsyncThunk(
  actionTypes.GET_ORGANIZATION,
  async ({ type }: { type: 'linkedIn' | 'all' }, { getState }) =>
    await getOrganizationApi(getState(), type),
);
